'use client';

import { ShortcutsCheatsheet } from './shortcuts-cheatsheet';
import { useShortcutsCheatsheet } from './use-shortcuts-cheatsheet';

export function ShortcutsCheatsheetMonitor() {
  const { isOpen, close } = useShortcutsCheatsheet();
  return <ShortcutsCheatsheet isOpen={isOpen} onClose={close} />;
}
